import { MiscUtil } from 'src/shared/utilities/misc.util';

export class TotalUosVariance {
    private jobTitlesWithVariance: any[] = [];

    constructor() {}

    public getVarianceWarnings(): string[] {
        let warningMessages = [];
        let warning: string;

        let variableVariancesForBlock = this.sortVariances(false);
        let fixedVariancesForBlock = this.sortVariances(true);
    
        if (!variableVariancesForBlock && !fixedVariancesForBlock) {
            return [];
        }

        variableVariancesForBlock.concat(fixedVariancesForBlock).forEach(variance => {
            let difference = variance.difference;

            warning = Math.sign(difference) === 1 ?
                `${variance.abbreviation} Overplanned by ${ difference.toFixed(2) }`
                : `${variance.abbreviation} Underplanned by ${ Math.abs(difference).toFixed(2) }`;
            warningMessages.push(warning);
        });

        return warningMessages;
    }

    public hasVariance(): boolean {
        return MiscUtil.checkArray(this.jobTitlesWithVariance) && MiscUtil.isValidNonNegativeNumber(this.jobTitlesWithVariance.length);
    }

    public hasVarianceWarningMessages(): boolean {
        let varianceWarningMessages = this.getVarianceWarnings();

        return MiscUtil.checkArray(varianceWarningMessages)  && MiscUtil.isValidNonNegativeNumber(varianceWarningMessages.length);
    }

    private sortVariances(isFixed: boolean): any[] {
        let variancesForBlock = this.jobTitlesWithVariance.filter(j => j.isFixed === isFixed).sort((n1, n2) => {          
            if (n1.abbreviation > n2.abbreviation) {
                return 1;
            }

            if (n1.abbreviation < n2.abbreviation) {
                return -1;
            }  
            
            return 0;
        });

        return variancesForBlock;
    }

    public updateJobTitlesWithVariance(
        isFixed: boolean, 
        abbreviation: string, 
        jobTitleId: number, 
        amount: any, 
        recommended: any) {
        // Remove any previously created variance warnings for the shift block and job title.
        this.jobTitlesWithVariance = this.jobTitlesWithVariance.filter(j => j.jobTitleId !== jobTitleId);
        
        if (MiscUtil.isValidNumber(amount) && MiscUtil.isValidNumber(recommended) && amount != recommended) {
            this.jobTitlesWithVariance.push({
                abbreviation: abbreviation,
                difference: amount - recommended,
                isFixed: isFixed,
                jobTitleId: jobTitleId
            });
        } 
    }
}